import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ResourceProvider } from '../../providers/resource/resource';
import { StaticFileContent } from '../../models';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { catchError, map } from 'rxjs/operators';
import { inject } from '@angular/core';

export const StaticCustomerFileResolver: ResolveFn<StaticFileContent> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  resource: ResourceProvider = inject(ResourceProvider),
): Observable<StaticFileContent> => {
  const failsafeData: StaticFileContent = {
    header: 'Fehler beim Laden der Seite',
    body: _('general.text.error'),
    footer: '',
  };

  return resource.getGenericCustomerPage(route.paramMap.get('name') ?? '').pipe(
    map((d) => (d.body === null ? failsafeData : d)),
    catchError((e) => {
      console.error(e);
      return of(failsafeData);
    }),
  );
};
